import { MPAOperationType } from '@repo/api-gw-sdk';

const mpaOperations: Record<MPAOperationType, { name: string }> = {
  [MPAOperationType.MPA_OPERATION_TYPE_UNSPECIFIED]: {
    name: '',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_CREATE_BACKUP_POLICY]: {
    name: 'Create backup policy',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_DELETE_BACKUP_POLICY]: {
    name: 'Delete backup policy',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_RESTORE_RESOURCE]: {
    name: 'Restore resource',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_UPDATE_BACKUP_POLICY]: {
    name: 'Update backup policy',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_ADD_RESTORE_ACCOUNT]: {
    name: 'Connect restore account',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_REMOVE_SNAPSHOT_HOLD]: {
    name: 'Remove snapshot hold',
  },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_UPDATE_NOTIFICATION_POLICY]:
    {
      name: 'Update notification policy',
    },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_DELETE_NOTIFICATION_POLICY]:
    {
      name: 'Delete notification policy',
    },
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_UPDATE_INGESTION_PIPELINE]:
    {
      name: 'Update stream',
    },
};

export const MpaOperations = Object.fromEntries(Object.entries(mpaOperations));
